export default "__VITE_ASSET__HtBGzvaq__"